import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './sentiment.css';
import { updateMetricsForPortco } from '../../common/api/PortcoMetricsAPIHelper';
import getEmoji from '../../common/util/emoji';
import { SENTIMENT_METRIC_ID } from '../../common/util/constants'; 

const Sentiment = ({portcoId}) => {
    const defaultValue = 4;
    const [sentiment, setSentiment] = useState(3);
    const [emoji, setEmoji] = useState(getEmoji(sentiment));
    const [snackbar, setSnackbar] = useState({open: false, message: '', severity: 'success'});

    const handleSliderChange = (value) => {
        setSentiment(value);
        setEmoji(getEmoji(value));
    };

    const saveSentiment = async () => {
        const metricsToUpdate = [{
          "portco_id": parseInt(portcoId),
          "metric_id": parseInt(SENTIMENT_METRIC_ID),
          "metric_value": parseFloat(sentiment),
          "metric_reported_by_user_id": 1,
          "metric_reported_by_email": "rakesh@protagonist.co"
        }];
        
        try {
          await updateMetricsForPortco(metricsToUpdate);
          setSnackbar({open: true, message: 'Sentiment updated successfully.', severity: 'success'});
        } catch (error) {
          setSnackbar({open: true, message: 'Failed to update sentiment.', severity: 'error'});
        }
      };

      const handleCloseSnackbar = () => {
        setSnackbar(prevSnackbar => ({ ...prevSnackbar, open: false }));
      };

    return (
        <div>
            <div className="sentiment">
                <p>How do you feel about the company right now?</p>
                <span>{emoji}</span>
                <Slider 
                    min={1} 
                    max={5} 
                    defaultValue={defaultValue} 
                    value={sentiment} 
                    onChange={handleSliderChange}
                />
                <button className="ra__fundsform_button" onClick={saveSentiment}>Save</button>
            </div>
            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default Sentiment;
